import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { CompilingWidgetService } from '../../../services/compiling/widget.service';
import { NumericUpDownCustomization } from './numericupdown-edit';

@Component({
  selector: 'lib-numericupdown-compiling',
  imports: [ReactiveFormsModule, InputNumberModule],
  template: `
    @let widget = widgetService.widget();
    @let formControl = widgetService.formControl();
    @if (widget && formControl) {
      <div class="p-fluid flex w-full flex-col gap-2">
        <label for="data" class="whitespace-pre-line text-justify">{{
          widget.customization.description
        }}</label>
        <p-inputNumber
          [autofocus]="false"
          id="data"
          [formControl]="formControl"
          [max]="widget.customization.max"
          [min]="widget.customization.min"
          [step]="widget.customization.step"
          (onKeyDown)="onKeyDown($event)"
          class="w-full rounded-md bg-white"
          decrementButtonClass="b-0 m-0 p-0 bg-accent"
          incrementButtonClass="b-0 m-0 p-0 bg-accent"
        />
      </div>
    }
  `,
  styleUrls: ['../style.css'],
  providers: [],
})
export class NumericUpDownCompilingComponent {
  protected widgetService = inject(
    CompilingWidgetService<NumericUpDownCustomization>,
  );

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }
}
